import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import { loadCollageOrganizations } from '../../actions';
import HomeCollage from '../../components/HomeCollage';

export default class SharedStoryStep5 extends Component {
  constructor(props) {
    super(props);
  }

  render() {


    return(
      <div className="sharedStory-step2Wrapper">
        <div className="sharedStoryWrapper">
          <p>
            Thank you for sharing your story with us. We are grateful to have you as part of the WorldWideWomen global community. You will hear from us shortly if we choose to share your responses on our website.</p>

            <p>Be sure to spend some time on the site to discover amazing resources, read inspiring stories, and share with your friends!
          </p>
          <div className="sharedStory-thankyouImgWrapper">
            <img src="images/shared_stories/thankyou_photo.jpg" />
          </div>
        </div>
      </div>
    )
  }
};



// WEBPACK FOOTER //
// ./src/components/sharedStory/SharedStoryStep5.jsx